<app-dialog-header [title]="'PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <p class="mb-12">{{ 'PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.DESCRIPTION' | translate }}</p>
    <form class="change-email-address-form" [formGroup]="formGroup">
        <mat-form-field>
            <mat-label>{{ 'PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.LABEL.CURRENT_EMAIL' | translate }} {{ user.email }}</mat-label>
            <input [placeholder]="'PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.PLACEHOLDER.NEW_EMAIL' | translate" matInput type="text" formControlName="email" />
        </mat-form-field>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onChangeUserEmailAddress()" [disabled]="!formGroup.valid || loading" [isLoading]="loading"></app-flat-button>
</div>
